import { RequestHandler } from 'express';
import { saveRecorded } from '../mockingMiddleware';
import { EntriesResult, MigrateRequest } from '~/services';
import CopyFieldService from '~/services/CopyFieldService';
import UpdateFieldService from '~/services/UpdateFieldService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';

export const copyEntryField: RequestHandler = async (req, res, next) => {
  const payload = res.locals.payload as MigrateRequest;
  const preview = !!res.locals.preview;
  let response = { committed: !preview } as Partial<EntriesResult>;

  try {
    const copyFieldService = new CopyFieldService(payload, preview !== false);

    const results = await copyFieldService.MigrateFieldContent();

    response = { ...response, ...results };

    res.send(response);
  } catch (ex: any) {
    const error = mapAppErrorToObject(ex);
    // update response object so mocks can be recorded for tests
    response = { ...response, error };
    res.status(error.status || 500).send(response);
  } finally {
    saveRecorded(req, res, {
      operation: 'copyEntryField',
      response,
    });
  }
  next();
};

export const updateEntryField: RequestHandler = async (req, res, next) => {
  const payload = res.locals.payload as MigrateRequest;
  const preview = !!res.locals.preview;
  let response = { committed: !preview } as Partial<EntriesResult>;

  try {
    const updateFieldService = new UpdateFieldService(
      payload,
      preview !== false
    );

    const results = await updateFieldService.UpdateFieldContent();

    response = { ...response, ...results };

    res.send(response);
  } catch (ex: any) {
    const error = mapAppErrorToObject(ex);
    // update response object so mocks can be recorded for tests
    response = { ...response, error };
    res.status(error.status || 500).send(response);
  } finally {
    saveRecorded(req, res, {
      operation: 'updatEntryField',
      response,
    });
  }
  next();
};
